"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserSettings;

var _immutable = require("immutable");

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _Constants = require("../Constants");

var defaultState = (0, _immutable.Map)({
  status: _Constants.RequestStatus.UNINITIALIZED
});

function UserSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      data = action.data,
      userSettings = action.userSettings;

  switch (type) {
    case ActionTypes.SAVE_USER_SETTINGS_ATTEMPTED:
      return data;

    case ActionTypes.FETCH_USER_SETTINGS_ATTEMPTED:
      return state.set('status', _Constants.RequestStatus.PENDING);

    case ActionTypes.FETCH_USER_SETTINGS_SUCCEEDED:
      return userSettings.set('status', _Constants.RequestStatus.SUCCEEDED);

    case ActionTypes.FETCH_USER_SETTINGS_EMPTY:
      return state.set('status', _Constants.RequestStatus.SUCCEEDED);

    case ActionTypes.FETCH_USER_SETTINGS_FAILED:
      return state.set('status', _Constants.RequestStatus.FAILED);

    default:
      return state;
  }
}

module.exports = exports.default;